<template>
  <EdroneTooltip
    :disabled="!isDisabled"
    max-width="200"
    :helper="trans._products.content.promotionDisabledTooltip"
    trigger-event="mouseenter"
  >
    <EdroneToggle
      unique-id="PageProducts_RecommendationStatusToggle_Clicked"
      :checked="isChecked"
      controlled
      :disabled="isDisabled"
      @click="handleClick"
    />
  </EdroneTooltip>
</template>

<script setup lang="ts">
import EdroneToggle from "edrone-components/EdroneToggle.vue";
import EdroneTooltip from "edrone-components/EdroneTooltip.vue";
import { computed } from "vue";
import { PRODUCT_RECOMMENDATION_STATUS } from "vue-app/components/ProductReport/ProductReport.enum";

interface Props {
  recommendationStatus: PRODUCT_RECOMMENDATION_STATUS;
  isDisabled?: boolean;
}

interface Emits {
  updateRecommendationStatus: [status: PRODUCT_RECOMMENDATION_STATUS];
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const handleClick = (value: boolean) => {
  if (value) {
    emit("updateRecommendationStatus", PRODUCT_RECOMMENDATION_STATUS.DEFAULT);
    return;
  }

  emit("updateRecommendationStatus", PRODUCT_RECOMMENDATION_STATUS.EXCLUDED);
};

const isChecked = computed(() => {
  return props.recommendationStatus === PRODUCT_RECOMMENDATION_STATUS.DEFAULT;
});
</script>
